export default __webpack_public_path__ + "static/media/yogurt_fruit.7d96991f.jpg";